<template>
  <div @click.stop :class="['cell-sets', 'new-btn-groups', offsetType]" :style="getHandleTopSite">
    <span class="icon icon-portal-arrows-up default-icon" style="display: none" @click.stop="activeSets($event)"></span>
    <handle-btn-groups
      class="upper-handle-items"
      ref="handleBtns"
      v-if="request_prefix !== 'bigScreen' && layoutIndex === ids.pageLayoutId && rect_id === ids.rect_id && setOnTop"
      :ids="ids"
      :isCanDel="canDel"
      :handleList="handleList"
      :isAllHandleBtns="false"
    />
    <div @mousedown.stop>
      <div class="set-groups-wrap" v-if="showComponentName">
        <div class="set-groups" @click.stop="displayAllHandles">
          <i class="icon icon-portal-container handle-icon-box"></i>
          <span>布局</span>
        </div>
      </div>
      <div class="set-groups-wrap">
        <cx-tooltip content="背景图" class="set-groups" v-if="layoutIndex === ids.pageLayoutId">
          <span class="icon icon-portal-bg-back handle-icon-box" @click.stop="openImgLib(curIndex)"></span>
        </cx-tooltip>
        <cx-tooltip
          content="背景色"
          v-if="layoutIndex === ids.pageLayoutId"
          class="set-groups"
          @click.native.stop="openBgColor()"
        >
          <!--        <span class="icon icon-portal-bg-color handle-icon-box"></span>-->
          <span class="icon icon-portal-color-paint bottom-color-wrap handle-icon-box"
            ><span class="bottom-color" :style="getBgColor"></span
          ></span>
          <span class="icon icon-portal-arrows-down" :class="showColorSelector ? 'rotate' : ''" style="color: #919191"></span>
          <color-selector
            v-if="showColorSelector"
            :background.sync="background"
            :visible.sync="showColorSelector"
          ></color-selector>
        </cx-tooltip>
        <cx-tooltip :content="curIndex === openIndex ? '收起此布局' : '展开此布局'" class="set-groups" v-if="layoutIndex === ids.pageLayoutId && isAccordionLayout" @click.native.stop="openAccordionLayout(curIndex)">
          <span class="icon icon-portal-max-width handle-icon-box"></span>
        </cx-tooltip>
        <span class="line" v-if="(curIndex > 0 || curIndex !== cellLen - 1) && layoutIndex === ids.pageLayoutId"></span>
        <cx-tooltip
          content="上移"
          class="set-groups"
          v-if="isRow && curIndex > 0 && layoutIndex === ids.pageLayoutId && layoutLevel < 4"
        >
          <span
            class="icon icon-direction-leftUp icon-portal-direction-left-2 handle-icon-box"
            @click.stop="moveToUp(curIndex)"
          ></span>
        </cx-tooltip>
        <cx-tooltip
          content="下移"
          class="set-groups"
          v-if="isRow && curIndex !== cellLen - 1 && layoutIndex === ids.pageLayoutId && layoutLevel < 4"
        >
          <span
            class="icon icon-direction-rightDown icon-portal-direction-right-2 handle-icon-box"
            @click.stop="moveToDown(curIndex)"
          ></span>
        </cx-tooltip>
        <cx-tooltip
          content="左移"
          class="set-groups"
          v-if="!isRow && curIndex > 0 && layoutIndex === ids.pageLayoutId && layoutLevel < 5"
        >
          <span class="icon icon-portal-direction-left-2 handle-icon-box" @click.stop="moveToLeft(curIndex)"></span>
        </cx-tooltip>
        <cx-tooltip
          content="右移"
          class="set-groups"
          v-if="!isRow && curIndex !== cellLen - 1 && layoutIndex === ids.pageLayoutId && layoutLevel < 5"
        >
          <span class="icon icon-portal-direction-right-2 handle-icon-box" @click.stop="moveToRight(curIndex)"></span>
        </cx-tooltip>
        <!-- <span class="line" v-if="layoutIndex === ids.pageLayoutId && ids.rect_id === rect_id "></span> -->
        <div class="set-groups handle-btn-name" @click.stop="handleShowRightToolbar">
          <span class="icon icon-portal-setting1"></span>
        </div>
        <cx-tooltip content="删除" class="set-groups" v-if="canDel">
          <span
            class="icon icon-portal-delete1 handle-icon-box del-click"
            @click.stop="delCol(cellVal, layoutIndex, curIndex)"
          ></span>
        </cx-tooltip>
      </div>
    </div>
    <handle-btn-groups
      class="upper-handle-items"
      ref="handleBtns"
      v-if="request_prefix !== 'bigScreen' && layoutIndex === ids.pageLayoutId && rect_id === ids.rect_id && !setOnTop"
      :ids="ids"
      :isCanDel="canDel"
      :handleList="reverseHandleList"
      :isAllHandleBtns="false"
    />
  </div>
</template>

<script>
import layoutCell from "./cell"
import draggable from "vuedraggable"
import $ from "jquery"
import { _throttle, isExist } from "utils"
import { deepCloneAndFreeze } from "utils/revork"
import { findParentIds } from "utils"
import handleBtnGroups from "components/publicComponent/handleBtnGroups"

export default {
  name: "cell-sets",
  components: {
    draggable,
    layoutCell,
    handleBtnGroups
  },
  data() {
    return {
      textOptions: {
        type: Array,
        default: []
      },
      activeTabId: "",
      appId: null,
      pageId: null,
      restDataUrl: null,
      typeVal: null,
      websiteId: null,
      wfwfid: null,
      colsIdFromActiveRect: [],
      cacheDataTypes: [],
      testData: [1, 2, 4],
      _self: this,
      resizeStartSite: null,
      activeIndex: undefined,
      paddingDragging: false,
      resizeSite: null,
      isResizing: false,
      parentW: null,
      maxCellLen: 6, //每行最多可以加到6列
      isTop: false, // 判断是否是第一个通栏的第一行内，此时的按钮位置朝下
      handleList: [],
      reverseHandleList: [],
      isShowAllBtns: false,
      showColorSelector: false,
      offsetLeft: 0,
      offsetType: "top-top" // top-top、top-bottom、bottom-top、bottom-bottom表示：从上往上排列，从上往下排列，从下往上排列，从下往下排列
    }
  },
  props: {
    id: {
      type: Number
    },
    rect_id: {
      type: Number
    },
    parentLayout: {
      type: Object,
      required: true
    },
    cell: {
      type: Object,
      required: true
    },
    curIndex: {
      type: [String, Number],
      required: true
    },
    layoutIndex: {
      type: [String, Number],
      required: true
    },
    offsetTop: {
      type: [String, Number],
      default: 0
    },
    offsetHeight: {
      type: [String, Number],
      default: 0
    },
    layoutLevel: {
      type: Number,
      required: true
    },
    isShowVerticalTabs: {
      type: Boolean,
      required: true
    },
    isShowTabs: {
      type: Boolean,
      required: true
    },
    isAccordionLayout: {
      type: Boolean,
      required: true
    },
    openIndex: {
      type: Number,
      required: true
    },
  },
  watch: {
    options: {
      deep: true,
      handler(o, n) {
        this.$forceUpdate()
      }
    },
    offsetTop(newVal) {
      const remainHeight = this.offsetTop >= 0 ? this.offsetHeight : this.offsetHeight + this.offsetTop
      if(newVal >= this.maxToolHeight) {
        this.offsetType = "top-top"
      } else if(remainHeight - this.maxToolHeight >= 100) {
        this.offsetType = "top-bottom"
      } else {
        this.offsetType = "bottom-bottom"
      }
    },
    scrollLeft(newVal, oldVal) {
      let element = document
        .getElementById(`rect_id_${this.rect_id}_layout_${this.layoutIndex}`)
        ?.getBoundingClientRect()
      let leftmenuWidth = document.getElementsByClassName("left-menu-wrap")[0]?.getBoundingClientRect()?.width || 0
      if (element.left < leftmenuWidth && element.left + element.width > leftmenuWidth) {
        this.offsetLeft = (leftmenuWidth - element.left) / this.zoom
      } else {
        this.offsetLeft = 0
      }
    }
  },
  computed: {
    zoom() {
      return this.$store.state.states.zoomActual
    },
    scrollLeft() {
      return this.$store.state.states.scrollLeft
    },
    getHandleTopSite() {
      if(this.offsetType === "top-top") {
        return {
          bottom: "100%",
          left: `${this.offsetLeft}`
        }
      } else if(this.offsetType === "bottom-bottom") {
        return {
          top: "100%",
          left: `${this.offsetLeft}`
        }
      } else {
        return {
          top: `${-this.offsetTop / this.zoom}px`,
          left: `${this.offsetLeft}`
        }
      }
    },
    ids() {
      return this.$store.state.states.activeID
    },
    canDel() {
      if (this.isShowTabs && this.isShowVerticalTabs) {
        // 布局标签大于指定层级的时候，可以删除
        if (this.layoutLevel < 6) {
          return false
        } else {
          return true
        }
      }
      if (this.isShowTabs && !this.isShowVerticalTabs) {
        // 布局标签大于指定层级的时候，可以删除
        if (this.layoutLevel < 5) {
          return false
        } else {
          return true
        }
      }
      if (this.isAccordionLayout && this.cellVal.options?.isAccordionLayoutCol) {
        let isRow = this.parentLayoutVal.rows.length ? true : false
        let layout = isRow ? this.parentLayoutVal.rows : this.parentLayoutVal.cols
        if (layout.length === 2) return false
      }
      if (this.ids.pageLayoutId !== this.layoutIndex) {
        return true
      }
      if (this.parentLayout.rows.length > 1 || this.parentLayout.cols?.length > 1) {
        return true
      } else {
        let ids = this.layoutIndex.split("_")
        let inDocument = this.pageLayoutList[ids[0]].options.inDocument
        if (
          (inDocument === "header" ||
            inDocument === "footer" ||
            inDocument === "anchor" ||
            this.pageLayoutList[ids[0]].options.enableBayWindow ||
            this.generalPageLayoutLen === 1) &&
          // this.judgeIsSingleCell(this.pageLayoutList[ids[0]].layout, 0) &&
          this.cellLen === 1
        ) {
          return false
        }
        return true
      }
    },
    isAdmin() {
      return this.$store.state.states.managerType === 1 ? true : false
    },
    showComponentName() {
      return this.$store.state.states.showComponentName
    },
    isRow() {
      //判断当前单元格是行还是列
      return this.parentLayout.rows.length > 0 ? true : false
    },
    cellLen() {
      return this.parentLayoutVal.rows.length > 0 ? this.parentLayoutVal.rows.length : this.parentLayoutVal.cols.length
    },
    parentLayoutVal: {
      get() {
        return this.parentLayout
      },
      set(newVal) {
        this.$emit("update:parentLayout", newVal)
      }
    },
    cellVal: {
      get() {
        return this.cell
      },
      set(newVal) {
        this.$emit("update:cell", newVal)
      }
    },
    layoutCols: {
      get() {
        return this.layout
      },
      set(val) {
        this.$emit("update:layout", val)
      }
    },
    pageLayoutList: {
      get() {
        return this.$store.state[this.request_prefix].page.pageLayoutList
      },
      set(val) {
        this.$store.dispatch(this.request_prefix + "/changePageLayout", { pageLayoutList: val })
      }
    },
    grandpaLayout: {
      get() {
        let newPageLayoutId
        let ids = this.layoutIndex?.toString().split("_")
        ids.splice(ids.length - 2, 2)
        newPageLayoutId = ids.join("_")
        return this.getAttrById.call(
          this,
          this.$store.state[this.request_prefix],
          { container_id: this.ids.container_id, rect_id: this.rect_id, pageLayoutId: newPageLayoutId },
          "pageLayout"
        )
      },
      set(newVal) {
        let newPageLayoutId
        let ids = this.layoutIndex.toString().split("_")
        ids.splice(ids.length - 2, 2)
        newPageLayoutId = ids.join("_")
        this.$store.dispatch(this.request_prefix + "/changePageLayoutRow", {
          pageLayoutId: newPageLayoutId,
          pageLayout: newVal
        })
      }
    },
    isPosition() {
      return this.cellVal.options.positionType && this.cellVal.options.positionType !== "relative" ? true : false
    },
    getBgColor() {
      let bg = this.isAccordionLayout && this.openIndex === this.curIndex ? this.cellVal.options.activeBackground : this.cellVal.options.bg
      let bgColorSet = bg?.find(item => item.type === "color")
      let bgColor = (bgColorSet && bgColorSet.color) || "rgba(255,255,255,0)"
      return {
        background: bgColor
      }
    },
    background: {
      get() {
        let background = this.cellVal.options.bg
        let bg = "bg"
        if (this.isAccordionLayout && this.openIndex === this.curIndex) {
          background = this.cellVal.options.activeBackground
          bg = "activeBackground"
        }
        if (background && Array.isArray(background) && background.length > 0) {
          return background
        }
        let newBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: false,
            color: this.cellVal.options.bgColor || "rgba(255,255,255,0)"
          }
        ]
        this.$changeOptionsEV(newBackground, bg, false, "", {
          container_id: this.ids.container_id,
          pageLayoutId: this.layoutIndex
        })
        return newBackground
      },
      set(val) {
        let bg = this.isAccordionLayout && this.openIndex === this.curIndex ? "activeBackground" : "bg"
        this.$changeOptionsEV(val, bg, false, "", {
          container_id: this.ids.container_id,
          rect_id: this.ids.rect_id,
          pageLayoutId: this.layoutIndex
        })
      }
    },
    setOnTop() {
      if (this.layoutIndex !== this.ids.pageLayoutId) {
        return true
      }
      return this.offsetType === "top-top" || this.offsetType === "bottom-top"
    },
    // 工具栏的整体高度
    maxToolHeight() {
      const handleItem  = this.$refs.handleBtns
      this.showMultipleName = handleItem && handleItem.$el.getElementsByClassName("displayBlock").length > 0 ? true : false
      const singleToolHeight = 34
      const singleToolMargin = 2
      const height = this.showMultipleName
        ? singleToolHeight + singleToolMargin * (this.handleList.length + 1)
        : singleToolHeight + singleToolMargin * 2
      return height
    }
  },
  mounted() {
    document.addEventListener("keydown", this.keyDelEvent)
  },
  methods: {
    activeSets(el) {
      let target = el.currentTarget
      $(".layout-container.set_active").removeClass("set_active active")
      $(".layout-col").removeAttr("data-level")
      $(".page-layout-wrapper").removeAttr("data-level")
      $($($(target).parent(".cell-sets").parent(".layout-sets")[0]).parent(".layout-container")[0]).addClass(
        "active set_active"
      )
      $(target).parents(".page-layout-wrapper").attr("data-level", "top-level")
      $(target).parents("li.layout-col").attr("data-level", "top-level")
      $(target).parents(".page-layout-wrapper").find(".page-layout-sets-wrap").addClass("hide")
      // 设置栏激活当前布局
      this.$store.commit("states/changeActiveID", {
        container_id: this.ids.container_id,
        rect_id: this.rect_id,
        pageLayoutId: this.layoutIndex
      })
      this.$store.commit("states/changeElementType", "cxPageLayoutComponentCell")

      // 此处的作用是清除其他激活状态
      this.$store.dispatch(this.request_prefix + "/setActive", {
        container_id: this.id,
        pageLayoutId: this.layoutIndex
      })
    },
    getHandelBtns() {
      this.isShowAllBtns = false
      this.handleList = []
      this.handleList = findParentIds(
        this.ids,
        this.$store.state[this.request_prefix].page.pageLayoutType,
        this.$store.state[this.request_prefix]
      )
      this.handleList.forEach(item=> {
        if (item.name?.trim() === '布局' && !isExist(item.ids.rect_id)) {
          item.name = '内容区'
        }
      })
      this.reverseHandleList = JSON.parse(JSON.stringify(this.handleList))
      this.reverseHandleList.reverse()
    },
    dragoverEv() {
      console.log("over")
    },
    changeOrder() {
      console.log("change 顺序")
    },
    // 重置贴边元素的横纵坐标
    restLeftTop(layout, type) {
      if (layout?.rectIds?.length > 0) {
        layout.rectIds?.forEach(item => {
          let elementNode = document.getElementsByClassName(
            "container_id_" + this.ids.container_id + "-rect_id_" + item
          )
          if (!elementNode || elementNode.length === 0) return
          let parentNode = elementNode[0].parentNode
          if (!parentNode) return
          const page = this.$store.state[this.request_prefix].page
          const containerIndex = page.children.findIndex(container => container.container_id === this.ids.container_id)
          if (containerIndex === -1) return
          const rectItem = page.children[containerIndex].children.find(rect => rect.rect_id === item)
          if (rectItem && rectItem.options) {
            if (type === "col" && rectItem.options?.leftType !== "%") {
              // 贴边元素新增列时会显示在布局外面 设置最大左偏移值
              let maxLeft = parentNode?.offsetWidth - elementNode[0].offsetWidth
              if (Number(rectItem.options.left) > Number(maxLeft)) {
                this.$changeOptionsEV(maxLeft, "left", false, null, {
                  container_id: this.ids.container_id,
                  rect_id: item
                })
              }
            }
            if (type === "row" && rectItem.options?.topType !== "%") {
              // 贴边元素新增行时会显示在布局外面 设置最大上偏移值
              let maxTop = parentNode?.offsetHeight - elementNode[0].offsetHeight
              if (Number(rectItem.options.top) > Number(maxTop)) {
                this.$changeOptionsEV(maxTop, "top", false, null, {
                  container_id: this.ids.container_id,
                  rect_id: item
                })
              }
            }
          }
        })
      }
    },
    // 重新写入新的rect 放在webJson中
    reWriteRect(newCol) {
      this.getRect(newCol)
    },
    // 获取rect
    getRect(col) {
      if (col.layout.rows.length > 0) {
        col.layout.rows.forEach(layout => {
          this.getRect(layout)
        })
      } else if (col.layout.cols.length) {
        col.layout.cols.forEach(layout => {
          this.getRect(layout)
        })
      } else {
        col.rectIds.forEach((item, index) => {
          let rectAttr = this.getAttrById(
            this.$store.state[this.request_prefix],
            {
              container_id: 0,
              rect_id: item
            },
            "rect"
          )
          this.$emit("reWriteRect", {
            rectAttr: rectAttr,
            cellRect: col.rectIds,
            index: index,
            type: "edit",
            isClone: true
          })
        })
      }
    },
    // 上移   只有行才能上移
    moveToUp(curIndex) {
      // if (this.ids?.pageLayoutId !== this.layoutIndex) {
      //   $(this.$el).find(".default-icon").click()
      // }
      let parentRow = this.isRow ? this.parentLayoutVal.rows : this.parentLayoutVal.cols
      let curLayout = parentRow[curIndex - 1]
      parentRow.splice(curIndex - 1, 1)
      parentRow.splice(curIndex, 0, curLayout)
      // 移动应该把当前激活布局一并修改
      let layoutId = this.layoutIndex.split("_")
      layoutId.splice(layoutId.length - 1, 1, curIndex - 1)
      layoutId = layoutId.join("_")
      this.$store.commit("states/changeActiveID", { container_id: this.id, pageLayoutId: layoutId })
    },
    // 下移 只有行才能下移
    moveToDown(curIndex) {
      // if (this.ids?.pageLayoutId !== this.layoutIndex) {
      //   $(this.$el).find(".default-icon").click()
      // }
      let parentRow = this.isRow ? this.parentLayoutVal.rows : this.parentLayoutVal.cols
      let curLayout = parentRow[curIndex]
      parentRow.splice(curIndex, 1)
      parentRow.splice(curIndex + 1, 0, curLayout)
      // 移动应该把当前激活布局一并修改
      let layoutId = this.layoutIndex.split("_")
      layoutId.splice(layoutId.length - 1, 1, curIndex + 1)
      layoutId = layoutId.join("_")
      this.$store.commit("states/changeActiveID", { container_id: this.id, pageLayoutId: layoutId })
    },
    // 左移  只有列才能左移 右移动
    moveToLeft(curIndex) {
      // if (this.ids?.pageLayoutId !== this.layoutIndex) {
      //   $(this.$el).find(".default-icon").click()
      // }
      let parentCol = this.isRow ? this.parentLayoutVal.rows : this.parentLayoutVal.cols
      let curLayout = parentCol[curIndex - 1]
      parentCol.splice(curIndex - 1, 1)
      parentCol.splice(curIndex, 0, curLayout)
      // 移动应该把当前激活布局一并修改
      let layoutId = this.layoutIndex.split("_")
      layoutId.splice(layoutId.length - 1, 1, curIndex - 1)
      layoutId = layoutId.join("_")
      this.$store.commit("states/changeActiveID", { container_id: this.id, pageLayoutId: layoutId })
    },
    // 右移 只有列才能左移 右移动
    moveToRight(curIndex) {
      // if (this.ids?.pageLayoutId !== this.layoutIndex) {
      //   $(this.$el).find(".default-icon").click()
      // }
      let parentCol = this.isRow ? this.parentLayoutVal.rows : this.parentLayoutVal.cols
      let curLayout = parentCol[curIndex]
      parentCol.splice(curIndex, 1)
      parentCol.splice(curIndex + 1, 0, curLayout)
      // 移动应该把当前激活布局一并修改
      let layoutId = this.layoutIndex.split("_")
      layoutId.splice(layoutId.length - 1, 1, curIndex + 1)
      layoutId = layoutId.join("_")
      this.$store.commit("states/changeActiveID", { container_id: this.id, pageLayoutId: layoutId })
    },
    delElementHandle(cellVal, hasNoConfirm) {
      let _this = this
      if (hasNoConfirm) {
        // 删除布局，再删除布局里的组件，此时不需要提示框
        cellVal.rectIds?.forEach(rectId => {
          _this.$store.dispatch(_this.request_prefix + "/deleteElement", {
            container_id: _this.id,
            rect_id: rectId
          })
        })
        return
      }
      sessionStorage.setItem("isDeletingConfirm", true)
      // 删除整个组件
      this.$confirm("确认删除吗？", "", {
        confirmButtonText: "删除",
        cancelButtonText: "取消",
        showClose: false,
        dangerouslyUseHTMLString: "<p>确认删除吗？</p>",
        iconClass: `${this.request_prefix}_confirm_icon el-icon-warning`,
        cancelButtonClass: `${this.request_prefix}_confirm_cancel_button`,
        confirmButtonClass: `${this.request_prefix}_confirm_button`,
        customClass: `${this.request_prefix}_confirm custom_warning_dialog`
      })
        .then(() => {
          sessionStorage.removeItem("isDeletingConfirm")
          _this.$store.dispatch(_this.request_prefix + "/deleteElement", {
            container_id: _this.id,
            rect_id: _this.rect_id
          })
          _this.$message({
            customClass: "bigScreen_msg_backGroud",
            duration: 3000,
            type: "success",
            message: "删除成功"
          })
        })
        .catch(() => {
          sessionStorage.removeItem("isDeletingConfirm")
        })
    },
    keyDelEvent() {
      // 横向标签布局，只有在特定的布局的时候，允许快捷删除整个标签布局
      if (this.isTabPageLayout) {
        return
      }
      let ids = this.$store.state.states.activeID
      if (this.layoutIndex !== ids.pageLayoutId) return
      if (this.rect_id !== ids.rect_id) return
      let key = window.event.keyCode
      if (key === 46) {
        if(!sessionStorage.getItem("isDeletingConfirm")) {
          if (this.canDel) {
            this.delCol(this.cellVal, this.layoutIndex, this.curIndex)
          } else if (
            (this.isShowVerticalTabs && this.layoutLevel === 4 && this.curIndex === 0) ||
            (this.layoutLevel === 3 && this.curIndex === 0)
          ) {
            // 删除整个组件
            this.delElementHandle()
          }
        }
      }
    },
    // 选择父级设置项
    selectUpperLevel() {
      let curActiveItem = $(".layout-container.set_active")
      curActiveItem.removeClass("active set_active")
      curActiveItem.parent().parent().parent(".layout-container").addClass("active set_active")
      // 设置项定位到上一级
      let parentId = this.layoutIndex.split("_")
      parentId.splice(parentId.length - 1, 1)
      parentId = parentId.join("_")
      this.$store.commit("states/changeActiveID", {
        container_id: this.ids.container_id,
        rect_id: this.rect_id,
        pageLayoutId: parentId
      })
      this.$store.commit("states/changeElementType", "cxPageLayoutComponentCell")
    },
    // 展开父级工具栏
    displayAllHandles() {
      if (this.handleList.length === 0) {
        this.getHandelBtns()
      }
      this.$nextTick(() => {
        $(this.$el).find(".upper-handle-items .handle-btn-items").toggleClass("displayBlock")
        // 添加收起当前层级的工具栏
        this.isShowAllBtns = false
      })
    },
    handleShowRightToolbar() {
      if (this.ids?.pageLayoutId !== this.layoutIndex) {
        $(this.$el).find(".default-icon").click()
      }
      this.$store.commit("states/changeShowRightToolbarStatus", true)
    },
    openImgLib(curIndex) {
      setTimeout(() => {
        let parentRow = this.isRow ? this.parentLayoutVal.rows : this.parentLayoutVal.cols
        let curLayout = parentRow[curIndex]
        let bg = this.isAccordionLayout && this.openIndex === this.curIndex ? curLayout.options.activeBackground : curLayout.options.bg
        // let bg = curLayout.options.bg
        let index = bg.findIndex(item => item.type === "img")
        let defaultImage = document.getElementsByClassName("toolbar")[0].getElementsByClassName("default-image") // 没有图片时生成默认值
        if (index === -1 && defaultImage.length > 0) {
          defaultImage[0].click()
        }
        let openLib = document.getElementsByClassName("toolbar")[0].getElementsByClassName("open_lib_btn") // 打开资源库按钮
        if (openLib.length > 0) {
          openLib[0].click()
          sessionStorage.setItem("openResourceLib", true)
        }
      }, 50)
    },
    openBgColor() {
      setTimeout(() => {
        this.showColorSelector = !this.showColorSelector
      }, 50)
    },
    // 删除行 列
    delCol(cellVal, layoutIndex, index) {
      this.$confirm("确认删除吗？", "", {
        confirmButtonText: "删除",
        cancelButtonText: "取消",
        showClose: false,
        dangerouslyUseHTMLString: "<p>确认删除吗？</p>",
        iconClass: `${this.request_prefix}_confirm_icon el-icon-warning`,
        cancelButtonClass: `${this.request_prefix}_confirm_cancel_button`,
        confirmButtonClass: `${this.request_prefix}_confirm_button`,
        customClass: `${this.request_prefix}_confirm custom_warning_dialog`
      })
        .then(() => {
          this.delColHandle(cellVal, layoutIndex, index)
          this.$message({
            customClass: "bigScreen_msg_backGroud",
            duration: 3000,
            type: "success",
            message: "删除成功"
          })
        })
        .catch(() => {})
    },
    // 删除布局的操作
    delColHandle(cellVal, layoutIndex, index) {
      let isRow = this.parentLayoutVal.rows.length ? true : false
      let layout = isRow ? this.parentLayoutVal.rows : this.parentLayoutVal.cols
      let delFun = () => {
        // 记录下删除通栏和子元素信息
        let rect = this.getAttrById(
          this.$store.state[this.request_prefix],
          { container_id: this.id, rect_id: this.rect_id },
          "rect"
        )
        const before = deepCloneAndFreeze(rect)
        if (layout.length === 1) {
          // 没有兄弟元素的时候直接删除
          layout.splice(index, 1)
        } else {
          layout.splice(index, 1)
          // 方案1,有删除之后 宽度平分
          if (isRow) {
            if (layout.length === 1 && this.layoutLevel > 3) {
              // 将当前的行变成列
              let ids = this.ids.pageLayoutId?.toString().split("_")
              let upperIndex = ids[ids.length - 2]
              let curLayout = JSON.parse(JSON.stringify(layout[0]))
              curLayout.options.width = this.grandpaLayout.layout.cols[upperIndex].options.width
              curLayout.id = this.grandpaLayout.layout.cols[upperIndex].id
              this.$set(this.grandpaLayout.layout.cols, [upperIndex], curLayout)
            }
            let handelLevel = this.request_prefix === "bigScreen" ? 1 : 3
            if (this.layoutLevel > handelLevel) {
              layout.forEach(item => {
                item.options.height = 100 / layout.length + "%"
              })
            }
          } else {
            if (layout.length === 1) {
              // 将当前的列变成行
              let ids = this.ids.pageLayoutId?.toString().split("_")
              let upperIndex = ids[ids.length - 2]
              let curLayout = JSON.parse(JSON.stringify(layout[0]))
              if (this.grandpaLayout.layout.rows.length > 0) {
                curLayout.options.width = "100%"
                curLayout.options.height = this.grandpaLayout.layout.rows[upperIndex].options.height
                curLayout.id = this.grandpaLayout.layout.rows[upperIndex].id
                this.$set(this.grandpaLayout.layout.rows, [upperIndex], curLayout)
              } else {
                curLayout.options.height = this.grandpaLayout.layout.cols[upperIndex].options.height
                curLayout.id = this.grandpaLayout.layout.cols[upperIndex].id
                curLayout.options.width = this.grandpaLayout.layout.cols[upperIndex].width
                this.$set(this.grandpaLayout.layout.cols, [upperIndex], curLayout)
              }
            } else {
              let newWidth = 100 / layout.length + "%"
              layout.forEach(item => {
                item.options.width = newWidth
              })
            }
          }
          // 删除单元格之后将激活项转移到通栏上
          this.$store.commit("states/changeActiveID", { container_id: this.id, rect_id: this.rect_id })
          this.$store.commit("states/changeElementType", "cxPageLayoutComponent")
        }
        if (cellVal.options?.isAccordionLayoutCol) {
          // 删除手风琴布局格子
          const activeWidth = this.grandpaLayout.options?.activeWidth
          const colLen = layout.length
          if (this.openIndex === index) {
            this.$changeOptionsEV(0, "openIndex", false, null, {
              container_id: this.ids.container_id, 
              rect_id: this.rect_id,
              pageLayoutId: "0"
            })
          }
          let defaultWidth = ((100 - activeWidth) / (colLen - 1)).toFixed()
          this.$changeOptionsEV(defaultWidth, "defaultWidth", false, null, {
            container_id: this.ids.container_id, 
            rect_id: this.rect_id,
            pageLayoutId: "0"
          })
        }
        // 内部组件要备份，需要在删除单元格组件之前记录
        this.$addHistory({
          type: "delete",
          stateType: "deletePageLayoutCol",
          payload: {
            container_id: this.id,
            rect_id: this.rect_id,
            cellVal
          },
          before
        })
        // 删除单元格内的组件
        this.delElementHandle(cellVal, true)
      }
      delFun()
    },
    openAccordionLayout(index) {
      let openIndex = index
      if (this.openIndex === index) {
        index < this.cellLen - 1 ? openIndex++ : openIndex--
      }
      this.$changeOptionsEV(openIndex, "openIndex", false, null, {
        container_id: this.ids.container_id, 
        rect_id: this.ids.rect_id,
        pageLayoutId: "0"
      })
    }
  },
  beforeDestroy() {
    document.removeEventListener("keydown", this.keyDelEvent)
  }
}
</script>

<style scoped>
.icon.add-col {
  position: absolute;
  display: inline-block;
  width: 18px;
  height: 18px;
  line-height: 18px;
  text-align: center;
  background-color: var(--themeColor);
  color: #fff;
  top: 50%;
  right: -9px;
  margin-top: -9px;
  z-index: 9999;
  cursor: pointer;
}

.cell-sets {
  z-index: 10000;
  display: none;
}
.cell-sets-toolbar {
  position: absolute;
  height: 0;
  width: 0;
  opacity: 0;
  z-index: -1;
  top: -20px;
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;
  border-radius: 999px;
  background-color: #283959;
  padding: 0 8px;
  transition: opacity 0.4s;
  overflow-x: hidden;
}
.cell-sets-toolbar.isBottom {
  top: 0;
}
.cell-sets-toolbar .icon {
  display: inline-block;
  font-size: 18px;
  width: 34px;
  text-align: center;
  height: 34px;
  line-height: 34px;
  color: rgba(255, 255, 255, 0.8);
  cursor: pointer;
}
.cell-sets-toolbar .icon:hover {
  color: rgba(255, 255, 255, 1);
}
.cell-sets-toolbar .set-groups {
  display: inline-block;
  vertical-align: middle;
}
.cell-sets-toolbar .set-groups .cx-tooltip {
  display: inline-block;
}
.cell-sets-toolbar .set-groups:not(:last-child) {
  border-right: 1px solid #42516d;
}

.cell-sets-toolbar:before {
  display: block;
  content: "";
  position: absolute;
  bottom: -12px;
  left: 50%;
  transform: translateX(-50%);
  border-width: 6px;
  border-style: solid;
  border-color: #283959 transparent transparent;
}
.cell-sets-toolbar.isBottom:before {
  top: -12px;
  bottom: auto;
  border-color: transparent transparent #283959;
}
.default-icon {
  display: inline-block;
  font-size: 16px;
  width: 18px;
  height: 18px;
  line-height: 18px;
  text-align: center;
  background-color: var(--themeColor);
  color: #fff;
  border-radius: 50%;
  transition: all 0.1s;
  cursor: pointer;
}

.default-icon:hover {
  transform: scale(1.3);
}
.mover,
.submover {
  display: none;
  width: 18px;
  height: 18px;
  line-height: 18px;
  text-align: center;
  background-color: var(--themeColor);
  color: #fff;
  border-radius: 50%;
  transform: scale(1.3);
  cursor: pointer;
}
.set-groups .disabled {
  opacity: 0.3;
}
/*2023.7.31 新样式*/
.new-btn-groups {
  position: absolute;
  left: 0;
  top: auto !important;
  bottom: calc(100% - 2px);
}
.new-btn-groups .default-icon {
  display: none;
}
.new-btn-groups.is_top {
  margin-top: -2px;
  bottom: unset;
}
::v-deep .icon-direction-leftUp {
  display: inline-block;
  transform: rotate(90deg);
}
::v-deep .icon-direction-rightDown {
  display: inline-block;
  transform: rotate(90deg);
}
.line {
  display: inline-block;
  vertical-align: middle;
  height: 20px;
  width: 1px;
  background-color: var(--topOperationBorderColor);
  margin: 0 2px;
}
</style>
